import Popover from 'trunks/vue/admin/components/libs/popover.js';
import SearchList from 'trunks/vue/admin/components/search/search_list.js';
import ChipInput from 'trunks/vue/admin/components/libs/chip_input.js';

export default {
  components: {
    'search-list': SearchList,
    Popover,
    'chip-input': ChipInput,
  },

  props: {
    remote: {
      type: String,
    },
  },

  data() {
    return {
      selectedItems: [],
      items: [],
      keyword: '',
      currentPage: null,
      fetching: false,
    };
  },

  computed: {
    selectedItemIds() {
      return _.pluck(this.selectedItems, 'id');
    },
  },

  created() {
    this.fetchItems();
  },

  methods: {
    selectedClass(item) {
      return {
        'slp-check-circle': item._selected,
        'slp-empty': !item._selected,
      };
    },

    unselect(item) {
      this.$refs.searchListVm.unselect(item);
    },

    clearKeyword() {
      this.$refs.chipInput.clear();
    },

    updateKeyword(keyword) {
      if (keyword === this.keyword) return;

      this.keyword = keyword;

      if (_.isEmpty(this.keyword)) {
        this.currentPage = null;
      } else {
        this.currentPage = 1;
      }

      this.items = [];
      this.fetchItems();
    },

    valueChanged(item) {
      if (item._selected) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = _.without(this.selectedItems, item);
      }

      this.$emit('valueChanged', this);
    },

    fetchItems() {
      if (this._isAllLoaded()) return;
      if (this.fetching) return;

      this.fetching = true;

      Skylark.Libs.Ajax.get(
        Skylark.Helpers.UrlHelper.generateUrlWithParams(this.remote, { page: this.currentPage, name: this.keyword }),
        {
          success: (data, xhr) => {
            this._addItems(data);

            const totalPage = parseInt(xhr.getResponseHeader('X-SLP-Total-Pages')) || 1;

            if (this.currentPage < totalPage) {
              this.currentPage += 1;
            } else {
              this.currentPage = null;
            }
          },
          complete: () => {
            this.fetching = false;
            this.$nextTick(() => this._calculatePopoverPosition());
          },
        },
      );
    },

    _formatItems(data) {
      return _.map(data, (item) => (
        _.findWhere(this.selectedItems, { id: item.id }) || _.tap(item, (obj) => { obj._selected = false; })
      ));
    },

    _isAllLoaded() {
      return this.currentPage == null;
    },

    _addItems(items) {
      if (this.currentPage === 1) {
        this.items = this._formatItems(items);
      } else {
        this.items = _.union(this.items, this._formatItems(items));
      }
    },

    _calculatePopoverPosition() {
      this.$refs.popoverVm.calculatePosition();
    },
  },
};
